var _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoOl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.53,21.98c-.83,0-1.5-.67-1.5-1.5V9.16l-3.06,1.53c-.75,.37-1.64,.07-2.01-.67-.37-.74-.07-1.64,.67-2.01l5.24-2.62c.47-.23,1.02-.21,1.46,.07,.44,.27,.71,.76,.71,1.28v13.75c0,.83-.67,1.5-1.5,1.5Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.69,42.76c-.48,0-.95-.22-1.24-.62-.75-1.04-.4-1.43,1.85-3.98,1.29-1.46,4.27-4.83,4.76-5.86-.07-.52-.79-1.32-1.81-1.52-.53-.07-1.8,.75-2.57,1.53-.58,.6-1.52,.62-2.12,.04-.6-.58-.61-1.53-.04-2.12,.46-.48,2.9-2.84,5.29-2.4,2.47,.47,4.37,2.6,4.25,4.75-.06,1.08-1.12,2.57-5.07,7.05,1.32,0,3.12,.04,5.58,.11,.83,.03,1.48,.72,1.46,1.54-.03,.81-.69,1.46-1.5,1.46h-.04c-3.57-.11-7.63-.16-8.39-.05-.14,.04-.27,.05-.41,.05Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.21,12.91H20.24c-1.11,0-2-.89-2-2s.89-2,2-2h21.97c1.11,0,2,.89,2,2s-.89,2-2,2Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.21,26.9H20.24c-1.11,0-2-.89-2-2s.89-2,2-2h21.97c1.11,0,2,.89,2,2s-.89,2-2,2Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.21,40.89H20.24c-1.11,0-2-.89-2-2s.89-2,2-2h21.97c1.11,0,2,.89,2,2s-.89,2-2,2Z",
    fill: outlineColor
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoOl);
export default __webpack_public_path__ + "static/media/ico-ol.31d31075b68aeddd459a7778b7888582.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = false;